// File: src/services/commentService.js

import api from "@/api";

const commentService = {
  /**
   * Lấy tất cả comment của một task
   * GET /api/tasks/{taskId}/comments
   */
  getAllByTaskId(taskId,params) {
    return api.get(`/api/tasks/${taskId}/comments`,{ params });
  },

  /**
   * Tạo một comment mới
   * POST /api/tasks/{taskId}/comments
   */
  create(taskId, commentData) {
    // commentData nên là một object, ví dụ: { content: "Nội dung bình luận" }
    return api.post(`/api/tasks/${taskId}/comments`, commentData);
  },

  /**
   * Cập nhật một comment
   * PUT /api/tasks/{taskId}/comments/{commentId}
   */
  update(taskId, commentId, commentData) {
    return api.put(`/api/tasks/${taskId}/comments/${commentId}`, commentData);
  },

  /**
   * Xóa một comment
   * DELETE /api/tasks/{taskId}/comments/{commentId}
   */
  deleteById(taskId, commentId) {
    return api.delete(`/api/tasks/${taskId}/comments/${commentId}`);
  },

  /**
   * Ghim một comment
   * POST /api/tasks/{taskId}/comments/{commentId}/pin
   */
  pin(taskId, commentId) {
    return api.post(`/api/tasks/${taskId}/comments/${commentId}/pin`);
  },

  /**
   * Bỏ ghim một comment
   * DELETE /api/tasks/{taskId}/comments/{commentId}/pin
   */
  unpin(taskId, commentId) {
    return api.delete(`/api/tasks/${taskId}/comments/${commentId}/pin`);
  },
};

export default commentService;